import { render, staticRenderFns } from "./BalanceHistory.vue?vue&type=template&id=3611b7d3&scoped=true"
import script from "./BalanceHistory.vue?vue&type=script&lang=js"
export * from "./BalanceHistory.vue?vue&type=script&lang=js"
import style0 from "./BalanceHistory.vue?vue&type=style&index=0&id=3611b7d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3611b7d3",
  null
  
)

export default component.exports